const en = {
  ID_CHAT_MENU_PROFILE: "View Profiles",
  ID_CHAT_MENU_REPORT: "Report Chatting",
  ID_CHAT_MENU_BLOCK: "Block User",
  ID_CHAT_INPUT_PLACEHOLDER: "Talk to your friend.",
  ID_WORLD_CHAT_POPUP_TITLE: "World Chat Message",
  ID_WORLD_CHAT_POPUP_PLACEHOLDER: "Please enter a world chat message.",
  ID_WORLD_CHAT_POPUP_CONFIRM: "Send",
  ID_INVALIDATION_BAD_WORD_1ST:
    "[System] Banned word 1st warning: Banned word accumulated 5 times and cannot chat for 5 minutes. ({ttl} left)",
  ID_INVALIDATION_BAD_WORD_2ST:
    "[System] Forbidden word 2nd warning: Forbidden word 1st warning accumulated 3 times and cannot chat for 24 hours. ({ttl} left)",
  ID_INVALIDATION_REPORT_WORD_1ST:
    "[System] Chat 1st warning: Chat reports accumulated 5 times and cannot be chatted for 5 minutes. ({ttl} left)",
  ID_INVALIDATION_REPORT_WORD_2ST:
    "[System] Chat 2nd Warning: Chat 1st warning accumulated 3 times and cannot chat for 24 hours. ({ttl} left)",
  ID_INVALIDATION_WORLD_CHAT_COOL_TIME: "[System] You need time to use World Chat. ({ttl} left)",
  ID_INVALIDATION_NOT_USER_EXIST: "[System] No user exists within the world",
  ID_INVALIDATION_CONNECTION_ERROR: "[System] chat has been disconnected. Please refresh and try again.",
  ID_FLOATING_NOTI_REPORT: "You have successfully reported.",
  ID_FLOATING_NOTI_BLOCK: "Blocked {user}",
  ID_DROP_MENU_PLAY: "Play",
  ID_DROP_MENU_AVATAR: "Avatar",
  ID_DROP_MENU_STUDIO: "Studio",
  ID_DROP_MENU_SOCIAL: "Social",
  ID_SEARCH_POPUP_START_CHAT: "Start",
  ID_SEARCH_NO_DATA: "There are no search results.",
  ID_SEARCH_INPUT_PLACEHOLDER: "Search",
  ID_PRIVATE_CHAT_PLACEHOLDER_WORLD: "There are no users in the world.",
  ID_PRIVATE_CHAT_PLACEHOLDER_FOLLOWERS: "There are not any followers.",
  ID_PRIVATE_CHAT_PLACEHOLDER_FOLLOWING: "There are not any following users.",
  ID_PRIVATE_CHAT_MESSAGE_OPTION: "General",
  ID_WORLD_PLAY_DROP_MENU_NOTICE: "Notice",
  ID_WORLD_PLAY_DROP_MENU_EXIT: "Exit",
  ID_CHAT_REPORT_REASON_INSULT: "Abusive language",
  ID_CHAT_REPORT_REASON_OBSCENE: "Lewd chat",
  ID_CHAT_REPORT_REASON_AD: "Advertisement",
  ID_CHAT_REPORT_REASON_ABUSE: "Chat Plaster",
  ID_CHAT_REPORT_REASON_FALSE_DISSEMINATION: "False Circulation",
};
export default en;
